
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Meta, Stepper } from "@/components/core";
import { PhoneConfirm, LogInEntrance } from "@/modules/login/index";
import { AccountEntranceLayout } from "@/components/layout/account-entrance";
import SecurityImage from "@/modules/login/security-image";
export default function LogInPage() {
    return (<AccountEntranceLayout>
      <Meta title="UPTION Tüzel Web Şube - Login"/>
      <Stepper hideStepLabels>
        <Stepper.Step key="log-in-entrance">
          <LogInEntrance />
        </Stepper.Step>
        <Stepper.Step key="confirm">
          <PhoneConfirm />
        </Stepper.Step>
        <Stepper.Step key="security-image">
          <SecurityImage />
        </Stepper.Step>
      </Stepper>
    </AccountEntranceLayout>);
}

    async function __Next_Translate__getStaticProps__1a1a8d50086__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/login/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1a8d50086__ as getStaticProps }
  